module.exports = __webpack_public_path__ + "img/header-background.c02dd87c.png";